module.exports = __webpack_public_path__ + "img/HenriSaison_140x140.f9d896bc.jpg";